// Self-hosted media for the starters (web/public/template-assets/v2, served at
// /template-assets/v2 on the app host and on every custom domain). Paths are
// relative here; the gallery runs localizeAssets() on a template when it creates
// a page, so the saved page holds absolute URLs (og:image, https checks).
import type { PageContent } from '../model/pages';
import { TEMPLATE_ASSETS } from '../model/pages';

const V2 = `${TEMPLATE_ASSETS}/v2`;

/** A v2 photo or mockup by file name (without extension). */
export const img = (name: string) => `${V2}/${name}.webp`;

/** 16 stock headshots for proof stacks and reviews (odd = women, even = men). */
export const AVATAR = (n: number) => img(`avatar-${String(n).padStart(2, '0')}`);
export const AVATARS = (from: number, count: number) => Array.from({ length: count }, (_, i) => AVATAR(((from - 1 + i) % 16) + 1));

/** Fictional grey wordmarks for logo strips (the owner swaps in real ones). */
export const LOGOS = (count = 6) => Array.from({ length: count }, (_, i) => `${V2}/logo-${String(i + 1).padStart(2, '0')}.svg`);

/** The shared footer every starter carries. */
export const footer = (id: string, name: string, extra: { label: string; href: string }[] = []): PageContent['footer'] => ({
  id, type: 'footer', body: `© 2026 ${name}. All rights reserved.`,
  links: [{ label: 'Privacy', href: '#' }, { label: 'Terms', href: '#' }, ...extra],
});
